export default class CronofyClient {
  constructor(http) {
    this.http = http;
    this.baseUrl = 'https://api.cronofy.com'
  }
  async getAvailability(elementToken, availabilityQuery) {
      const url = new URL('v1/availability', this.baseUrl).toString();
      const response = await this.http.post(
        url, 
        availabilityQuery, 
        {
          headers: { 
            'Content-Type': 'application/json', 
            'cronofy-element': 'v1.49.2, AvailabilityViewer'
          },
          params: { et: elementToken }
        });
      if(response.ok)
        return response.body;
      throw response;
  }
}